import { CheckStatus } from '../../models/checks-model';

/**
 * Mappt den Frontend-CheckStatus-Enum auf den Backend-CheckPhase-String.
 * Wird für PUT /check/{checkId}/stage/{stageId} benötigt (phase-Feld im Body).
 */
export function checkStatusToPhase(status: CheckStatus): string {
  switch (status) {
    case CheckStatus['Kontrolle 1-1']: return 'FIRST';
    case CheckStatus['Kontrolle 1-2']: return 'SECOND';
    case CheckStatus['Kontrolle 2']:   return 'REVIEW';
    default:                           return 'UNDEFINED';
  }
}

